<template>
  <v-dialog width="100%" max-width="360px" v-model="dialog_visible">
    <template #activator="{ on }">
      <v-list-item v-on="on" class="px-2" :key="lead.lead_id" style="background-color: #DDD1D2;">
        <StatusIcon status="locked" />
        <div class="flex-grow-1 pl-3" style="font-size: 14px">
          <div class="d-flex">
            <div><strong>Declined</strong></div>
            <div class="ml-auto text-body-2 grey--text">
              {{ formatDate(lead.lead_date) }}
            </div>
          </div>
          
          <div class="d-flex">
            <div class="mr-auto">{{ lead.service }}</div>
            <div>{{ lead.friendly_structure_type }}</div>
          </div>
        </div>
      </v-list-item>
    </template>

    <v-card>
      <v-card-title style="background-color: #004056" class="white--text">
        Lead Declined
      </v-card-title>

      <v-divider />
      
      <v-card-text class="mt-4">
        <p class="font-weight-bold">
          You declined this lead.
        </p>
        <p>
          If you have blocked <strong>{{ lead.service }}</strong> or 
          <strong>{{ lead.friendly_structure_type }}</strong> leads, and you've changed
          your mind, you can turn them back on here:
          <router-link :to="{ name: 'you/services'}">Lead Preferences</router-link>.
        </p>
      </v-card-text>

      <v-divider />

      <v-card-actions v-if="me.is_active" class="justify-center py-3">
        <v-btn @click="laterClick">Close</v-btn>
      </v-card-actions>

      <v-card-actions v-else class="justify-center py-3">
        <v-btn color="primary" @click="setupNowClick">Set Up Now</v-btn>
        <v-btn @click="laterClick">Later</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import StatusIcon from '@/components/StatusIcon'
import formatters from '@/lib/formatters'
import { mapGetters } from 'vuex'

export default {
  name: 'MissedLeadDialog',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  components: { StatusIcon },

  data() {
    return {
      dialog_visible: false,
    }
  },

  computed: {
    ...mapGetters('auth', ['me']),
  },

  methods: {
    ...formatters,

    setupNowClick() {
      window.history.replaceState(null, "", "/home")
      this.$router.push({ name: 'billing/account' })
    },

    laterClick() {
      this.dialog_visible = false
    },
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }

  .emphasis {
    font-weight: bold;
    color: green;
  }
</style>